import FlagRoundedIcon from "@mui/icons-material/FlagRounded";
import { colors, Tooltip } from "@mui/material";

import { FlaggingAnalyticsService } from "@analytics/index";

import { PopupActions } from "@store/popupStore";

import theme from "@theme/index";

import FlagDataModal from "../Forms/FlagData";

interface IRowFlagProperties {
  form: string;
  rowParams: {
    row: {
      id: string;
      name: string;
    };
  };
  workflow: string;
}

/**
 * Renders a flag icon that opens a modal to flag data.
 *
 * @param rowParams - The values from the flagged DataGrid row.
 * @param form - The form type to flag.
 * @param workflow - The current workflow.
 */
export default function RowFlag({ form, rowParams, workflow }: IRowFlagProperties) {
  return (
    <Tooltip title="Flag data issues for revision.">
      <FlagRoundedIcon
        onClick={() => {
          PopupActions.openModal({
            content: (
              <FlagDataModal
                flagCompanyIssue={(feedback, issue) => {
                  if (form === "company") {
                    FlaggingAnalyticsService.dataIssueFlagged(rowParams.row.id, issue, feedback, "company");
                  } else if (form === "contact") {
                    FlaggingAnalyticsService.dataIssueFlagged(rowParams.row.id, issue, feedback, "contacts");
                  }
                  PopupActions.closeModal();
                }}
                form={form}
              />
            ),
            title: `Let's flag this ${form}`,
          });
        }}
        sx={{
          "&:hover": {
            color: theme.palette.warning.main,
          },
          color: colors.grey[500],
          cursor: "pointer",
          fontSize: "1.25rem",
        }}
      />
    </Tooltip>
  );
}
